import React from 'react'
import './Shipping.css'

function Shipping() {
  return (
    <div className="shipping">
      <div className="wrapping">
        {/* Using real affiliate banner from Leksaksbilar.se */}
        <a href="https://on.leksaksbilar.se/t/t?a=1954031401&as=1971524470&t=2&tk=1" target="_blank" rel="noopener noreferrer">
          <img 
            src="https://track.adtraction.com/t/t?a=1954031401&as=1971524470&t=1&tk=1&i=1" 
            width="980" 
            height="120" 
            border="0"
            alt="Leksaksbilar.se - Bästa leksaksbilarna online"
            className="shipping__banner"
            onError={(e) => {
              console.log('Affiliate banner failed to load:', e.target.src);
            }}
            onLoad={() => {
              console.log('Affiliate banner loaded successfully');
            }}
          />
        </a>
      </div>
    </div>
  )
}

export default Shipping
